import React, { Component,useState } from "react";
import Titulo from "../../generico/TituloPagina";
import TransferCuentasTercerosService from "../../../services/transferencias/TransferCuentasTercerosService";
import { trackPromise } from "react-promise-tracker";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck  } from "@fortawesome/free-solid-svg-icons";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import zIndex from "@mui/material/styles/zIndex";
import MensajeUsuario from "../../generico/MensajeUsuario";


const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};

export default class SimuladorAhorros extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      
      monedasoptions: [],
      plazosMaximosoptions: [],
      monedaElegido: null,
      plazoElegido: null,
      inputValue: null,
      selectedMoneda: null,
      selectedPlazos: null,
      description: [],
      interesDiario: [],
      interesMensual: [],
      tasaInteres: [],
      totalInteres: []

    };

    
  }
  componentDidMount() {
    this.getParamsSimulador();
  }

 
  


  getParamsSimulador() {
    var respuesta = [];
    var respuestaplazo = [];
    trackPromise(
      TransferCuentasTercerosService.getParametrosSimulador().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        
   
          console.log("jDatafgfd", jData.datos.monedas)
          if(jData.datos.monedas !== null){
            
            for (var i = 0; i < jData.datos.monedas.length; i++) {
              var itemMoneda = jData.datos.monedas[i].descripcion;
              var itemIdMoneda = jData.datos.monedas[i].idMoneda;
              console.log("items simulador", itemIdMoneda)
              respuesta.push({
                  label:itemMoneda,
                  value: itemIdMoneda
              });
            }
            for (var i = 0; i < jData.datos.plazosMaximos.length; i++) {
              var itemPlazos = jData.datos.plazosMaximos[i];
              console.log("items simulador", itemPlazos)
              respuestaplazo.push({
                  label:itemPlazos,
                  value: itemPlazos
              });
            }
          }
          this.setState({
            monedasoptions: respuesta,
            plazosMaximosoptions:respuestaplazo
          });
        
      })
    );
  }





  getResultsSimulador() {
  
    trackPromise(
      TransferCuentasTercerosService.getResultadosSimulador(this.state.selectedMoneda,this.state.selectedPlazos,this.state.inputValue.replace(/\./g, '')).then((response) => {
        var data = JSON.stringify(response.data);
        var jDataSimulador = JSON.parse(data).datos;
        console.log("valores de Simulador", jDataSimulador)
        var jData = JSON.parse(data).codigo;
        console.log("valores de Simulador", jData)
        var respuesta = []
        for (var i = 0; i < jDataSimulador.length; i++) {
        
         
          console.log("valores de Descrp", jDataSimulador[i].descripcion)
          respuesta.push({
            description : jDataSimulador[i].descripcion,
            interesDiario: jDataSimulador[i].interesDiario,
            interesMensual: jDataSimulador[i].interesMensual,
            tasaInteres: jDataSimulador[i].tasaInteres,
            totalInteres: jDataSimulador[i].totalInteres
            
          })
        }
        console.log("valores res", respuesta)
        this.setState({description : respuesta});
        console.log(this.state.description);
      })
    );
  }



  handleMoneda = (element) => {
    const valueToParse = element.value;
    console.log({valueToParse});
    this.setState({ selectedMoneda: valueToParse });
    //this.props.inputValue(valueToParse, this.props.name, false, "", "OPTION", this.props.label);
    //console.log("VALOR SELECCIONADO COMBO " + valueToParse)
  }



  handleChangePlazos= (element) => {
    const valueToParse = element.value;
    console.log({valueToParse});
    this.setState({ selectedPlazos: valueToParse });
  }


  updateInputValue= (evt) => {
    const val = evt.target.value;
    console.log({val});
    // ...       
    this.setState({
      inputValue: formatoSeparadorMilesValue(val)
    });
  }

  


  render() {
    var descripcion = this.state.description

    return (
     

<div className="content-wrapper">
<Titulo texto="Simulador de Ahorros" />
<section className="content">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-body">
            <div className="row">
            <div className="col-md-12" style={{padding:'1rem'}}>
              <MensajeUsuario tipo="INFO"
                titulo="Importante"
                mensaje=" El monto máximo para ahorro programado es de 10.000.000Gs." />
              
            </div>
            <div className="row justify-content-md-center">
            
          </div>
              <div className="col-md-12">
              <label className="input-label-bold">Seleccione los items para el simulador *</label>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                <label className="input-label-bold">Tipo de moneda</label>
                  <Select
                    required="true"
                    placeholder="-- Seleccione moneda --"
                    
                    onChange={this.handleMoneda}
                    options={this.state.monedasoptions}
                    isClearable
                    noOptionsMessage={() => "SIN DATOS"}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                <label className="input-label-bold">Plazos de ahorros</label>
                  <Select
                    required="true"
                    placeholder="-- Seleccione plazo --"
                    onChange={this.handleChangePlazos}
                    options={this.state.plazosMaximosoptions}
                    isClearable
                    noOptionsMessage={() => "SIN DATOS"}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                <label className="input-label-bold">Monto a calcular</label>
                <input id="monto" name="monto" type="text" placeholder="monto a solicitar" style={{textTransform: "lowercase"}}
                             className="form-control input-box texto-maximo"  value={this.state.inputValue}
                             onChange={this.updateInputValue} />
                </div>
              </div>
              <div className="col-md-12">
              <button className="btn btn-cu-primary" onClick={() => this.getResultsSimulador()} ><FontAwesomeIcon icon={faCheck} /> Consultar</button>
              </div>

              <div className="col-md-12">
              <Titulo texto="Ahorros Solicitados" />
              
                {descripcion.map(elemento => (
                      <div className="card">
                      <div className="card-body" >
                      
                       <h3 className="titulo-simulador"> {elemento.description} </h3>
                       <div className="col-md-12">
                       <span> Interés diario: <b> {formatoSeparadorMilesValue(elemento.interesDiario)}</b></span>
                       </div>
                       <div className="col-md-12">
                       <span>Interés mensual: <b> {formatoSeparadorMilesValue(elemento.interesMensual)}</b></span>
                       </div>
                       <div className="col-md-12">
                       <span>Tasa de interés: <b>{elemento.tasaInteres} %</b></span>
                       </div>
                       <div className="col-md-12">
                       <span>Total de intereses: <b>{formatoSeparadorMilesValue(elemento.totalInteres)}</b></span>
                       </div>
                       
                       
                        </div>  
                      </div> 
                ))} 
              
               
          
                           
              </div>
              

            </div>
          </div>
         
      
        </div>
      </div>
    </div>
    
  </div>
</section>
</div>
    );
  }
}
